import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUpdated, ref } from 'vue';

import { FormItem } from '@/interfaces/lib/model';
import { textFormList } from '@/lib/formItem';
import {
  isNumberAndHyphenArray,
  required,
  requiredSelection,
} from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection1ImporterForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    name: null,
    address: null,
    department: null,
    phone: null,
    email: null
  },
  emits: ["update:isValid", "update:name", "update:address", "update:department", "update:phone", "update:email"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:name', data: string): void;
  (e: 'update:address', data: string): void;
  (e: 'update:department', data: string): void;
  (e: 'update:phone', data: string): void;
  (e: 'update:email', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const form = ref<InstanceType<typeof VForm> | null>(null);



const parsePhone = (phoneNumber: string): Array<string> => {
  return (phoneNumber || '').split('|').filter((item) => item.trim() !== '');
};

const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateName = (e: string): void => {
  emits('update:name', e);
};

const updateAddress = (e: string): void => {
  emits('update:address', e);
};

const updateDepartment = (e: string) => {
  emits('update:department', e);
};

const updatePhone = (e: Array<string | FormItem>): void => {
  const phoneList: Array<string> = [];
  for (const item of e) {
    if (typeof item == 'string') {
      if (item.trim() !== '') {
        phoneList.push(item);
      }
    } else if (item?.text) {
      if (item.text.trim() !== '') {
        phoneList.push(item.text);
      }
    }
  }
  emits('update:phone', phoneList.join('|'));
};

const updateEmail = (e: string): void => {
  emits('update:email', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

onUpdated((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,form, emits, parsePhone, updateIsValid, updateName, updateAddress, updateDepartment, updatePhone, updateEmail, textFormList, isNumberAndHyphenArray, required, requiredSelection, VForm, sharedMessages }
}

})